/**
 * @fileoverview GET handler for the "/engagement/campaigns/campaign_occurrences/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignOccurrencesAppGroupId } from "./constants";
import type { CampaignOccurrencesResult } from "./types";

export const getCampaignOccurrences = reactQueryFetcherAdapter(
  engagementCampaignsCampaignOccurrencesAppGroupId,
  (
    signal: AbortSignal,
    appGroupId: string,
    startTimestamp: number,
    endTimestamp: number
  ): Promise<CampaignOccurrencesResult> => {
    return fetch(
      `/engagement/campaigns/campaign_occurrences/${appGroupId}`,
      "GET",
      {
        start_time: startTimestamp,
        end_time: endTimestamp,
      },
      { signal }
    );
  }
);
